<template>
    <div>
        <div class="d-flex flex-stack flex-wrap">
            <div class="page-title d-flex flex-column me-3 mt-3">
                <h1 class="d-flex fw-bolder my-1 fs-3 text-gray-800">{{ $t('create_new_chequecard_operation') }} </h1>
                <ul class="breadcrumb breadcrumb-dot fw-bold text-gray-600 fs-7 my-1">
                    <li class="breadcrumb-item text-gray-600">
                        <a href="#" class="text-gray-600 text-hover-primary">
                            <router-link :to="{ name: 'Home' }">{{ $t('home') }}</router-link>
                        </a>
                    </li>
                    <li class="breadcrumb-item text-primary">{{ $t('transactions') }}</li>
                    <li class="breadcrumb-item text-gray-600">{{ $t('create_new_chequecard_operation') }}
                    <HelpPageIcon v-if="this.iconView == true" :menuSelection="this.menuSelection"></HelpPageIcon>
                    </li>
                </ul>
            </div>
            <div class="d-flex align-items-center py-1" v-if="getSubCredentials('R')">
                <button type="button" class="btn btn-light border border-gray-400" data-bs-toggle="modal" data-bs-target="#kt_modal_transaction_list" @click="onOpenTransactionListModal()" :disabled="!this.$getUser().is_allow_list_all_data && (this.form.operation_account_id == null || this.form.operation_account_id == undefined || this.form.operation_account_id == '-1')" >
                    <span class="svg-icon svg-icon-muted"><svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect y="6" width="16" height="3" rx="1.5" fill="currentColor"/>
                    <rect opacity="0.3" y="12" width="8" height="3" rx="1.5" fill="currentColor"/>
                    <rect opacity="0.3" width="12" height="3" rx="1.5" fill="currentColor"/>
                    </svg>
                    </span>
                    {{ $t('transaction_list') }}
                </button>
            </div>
        </div>
        <div class="content flex-row-fluid mt-2" id="kt_content"> 
            <RequiredField></RequiredField>
            <div class="card card-xxl-stretch">
                <div class="row p-4">
                    <form id="poliform" @submit.prevent="" class="form fv-plugins-bootstrap5 fv-plugins-framework">
                        <div class="row g-xxl-9">
                            <div class="col-lg-12">
                                <div class="card card-xxl-stretch mb-6 bg-lighten border border-gray-300">
                                    <div class="card-header">
                                        <div class="card-title">
                                            <h3>{{ $t('chequecard_operation') }}</h3>
                                        </div>
                                    </div>
                                    <div class="card-body pb-0">
                                        <div class="fv-row mb-7 row">
                                            <div class="col">
                                                <label class="fs-6 fw-bold form-label" v-tag="'record_date'">
                                                    {{ $t('record_date') }}
                                                </label>
                                                <Datepicker :locale="$datepickerLocale()"  name="record_date" v-custom :required="this.$checkIfDateFieldRequired ('record_date')" textInput :textInputOptions="{ format: 'dd.MM.yyyy' }" v-maska="'##.##.####'" v-model="form.record_date" format="dd.MM.yyyy" 
                                                    previewFormat="dd.MM.yyyy" autoApply :clearable="false" :enableTimePicker="false"
                                                    :minDate="getMinTransactionDate"/>
                                                <small class="text-info" v-if="userData.last_transaction_date !== null && userData.last_transaction_date !== undefined && userData.last_transaction_date !== ''">
                                                    {{ $t('the_last_transaction_date') }} {{previewDate(userData.last_transaction_date)}}. {{ $t('this_date_and_the') }}.
                                                </small>
                                            </div>
                                            <div class="col">
                                                <label class="fs-6 fw-bold form-label" v-tag="'record_type'">
                                                    {{ $t('record_type') }}
                                                </label>
                                                <Select2 name="record_type" v-custom v-model="form.record_type" :options="recordTypeFilteredList" @select="onChangeRecordType()" :settings="{ width: '100%' }" :disabled="this.chequeItemsList.length > 0" />
                                            </div>
                                            <div class="col">
                                                <label class="fs-6 fw-bold form-label" v-tag="'cheque_type'">
                                                    {{ $t('cheque_type') }}
                                                </label>
                                                <Select2 v-model="form.transaction_type" :options="transactionTypeListWithNoSelection" @select="onChangeChequeType()" name="cheque_type" v-custom 
                                                    :disabled="this.chequeItemsList.length > 0" :settings="{ width: '100%' }" />
                                            </div>
                                            <div class="col">
                                                <label class="fs-6 fw-bold form-label" v-tag="'operation_position'">
                                                    {{ $t('operation_position') }}
                                                </label>
                                                <Select2 v-model="form.cheque_position" :options="targetPositionList" name="operation_position" v-custom 
                                                    :disabled="this.chequeItemsList.length > 0" :settings="{ width: '100%' }" />
                                            </div>
                                            <div class="col-lg-3 col-md-6 col-sm-12">
                                                <label class="fs-6 fw-bold form-label" >
                                                    {{ $t('select_operation_account') }}
                                                </label>
                                                <div class="input-group">
                                                    <button type="button" class="btn rounded-start-0 btn-light btn-icon text-hover-primary border border-1 border-gray-300 z-index-0" data-bs-toggle="modal" data-bs-target="#kt_modal_account_report_selection" @click="onOpenAccountReport()"
                                                        v-if="form.operation_account_id !== null && form.operation_account_id !== '-1' && form.operation_account_id !== '' && form.operation_account_id !== undefined">
                                                        <i class="fa fa-eye text-gray-600 fs-3"></i>
                                                    </button>
                                                    <input type="search" class="form-control form-control-lg" v-model="form.operation_account_name" @input="form.operation_account_id = '-1'" :placeholder="$t('please_type_an_account')" :disabled="this.form.cheque_position == '-1'" @keyup.enter="onClickSearchButton()" >
                                                    <button ref="searchAccountButton" type="button" class="btn btn-sm btn-light-primary border border-gray-300 z-index-0" data-bs-toggle="modal" data-bs-target="#kt_search_account_modal" 
                                                        data-kt-indicator="on" :disabled="this.form.cheque_position == '-1'" @click="openSearchModal(form.operation_account_name)">
                                                        <i class="fa fa-search"></i>
                                                        {{ $t('search') }}
                                                    </button>
                                                </div>
                                                <small v-if="this.form.cheque_position !== '-1'">
                                                    <i class="bi bi-info-circle fs-7 me-1"> </i> 
                                                    <span> <b>{{ getAccountTypes }}</b>  {{ $t('accounts_can_be_searched') }} </span>
                                                </small>
                                            </div>
                                        </div> 
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 mt-0">
                                <div class="card card-xxl-stretch mb-6 bg-lighten border border-gray-300">
                                    <div class="card-body pb-0">
                                        <div class="p-0">
                                            <div class="d-flex flex-stack flex-wrap mb-2">
                                                <div class="d-flex justify-content-end" data-kt-docs-table-toolbar="base">
                                                    <button type="button" class="btn btn-sm btn-success fw-bold required me-3"
                                                        data-bs-toggle="modal" 
                                                        ref="btnAddItem" :disabled="this.form.cheque_position == '-1' || this.form.operation_account_id == '-1' || this.form.operation_account_id == null"
                                                        data-bs-target="#kt_modal_add_item"
                                                        @click="openModal()"
                                                        data-kt-menu-trigger="click" 
                                                        data-kt-menu-placement="bottom-end">
                                                        <span class="svg-icon svg-icon-2">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                                viewBox="0 0 24 24" fill="none">
                                                                <rect opacity="0.5" x="11.364" y="20.364" width="16" height="2" rx="1"
                                                                    transform="rotate(-90 11.364 20.364)" fill="currentColor"></rect>
                                                                <rect x="4.36396" y="11.364" width="16" height="2" rx="1"
                                                                    fill="currentColor">
                                                                </rect>
                                                            </svg>
                                                        </span> 
                                                        {{ $t('add_new') }}
                                                    </button>
                                                    <button type="button" class="btn btn-sm btn btn-light btn-active-danger" @click="deleteAllChequeItem(1)">
                                                        <span class="svg-icon svg-icon-2">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                                <rect x="6" y="11" width="12" height="2" rx="1" fill="currentColor"/>
                                                            </svg>
                                                        </span>
                                                        {{ $t('remove_all') }}
                                                    </button> 
                                                </div>
                                            </div>
                                            <div class="pb-10">
                                                <DxDataGrid id="gridContainer" :key="$i18n.locale" 
                                                        :show-borders="true" 
                                                        key-expr="id" 
                                                        :data-source="chequeItemsList" 
                                                        :allow-column-reordering="true"  
                                                        :allow-column-resizing="true" 
                                                        :column-auto-width="true" 
                                                        :row-alternatin-enabled="true"
                                                        :hover-state-enabled="true" 
                                                        :show-row-lines="true" 
                                                        :customize-columns="onCustomizeColumn"
                                                        @exporting="this.$onExporting($event , 'Cheque-transaction-items')"
                                                        @option-changed="handlePropertyChange"
                                                        @row-removing="deleteChequeItem"> 

                                                        <DxFilterRow :visible="true"/>
                                                        <DxHeaderFilter :visible="true"/>
                                                        <DxGroupPanel :visible="true"/>      
                                                        <DxExport :enabled="this.$getUser().is_allow_export" :formats="['xlsx','pdf']" :allow-export-selected-data="false"/>
                                                        <DxPaging :page-size="10"/>
                                                        <DxPager :visible="false" :allowed-page-sizes="pageSizes" :show-page-size-selector="showPageSizeSelector" :show-info="true" :show-navigation-buttons="true"/> 
                                                        <DxSearchPanel :visible="true"/> 
                                                        <DxScrolling
                                                            mode="virtual"
                                                            row-rendering-mode="virtual"
                                                        />
                                                        <DxEditing :allow-deleting="true"/>
                                                        <DxColumn type="buttons"/>
 
                                                        <DxColumn data-field="id" caption="" alignment="right" cell-template="id-cell-template" :allow-exporting="false"/> 
                                                        <DxColumn data-field="due_date" :caption="$t('due_date')" data-type="date" alignment="right" format="dd.MM.yyyy" header-cell-template="due_date-header" cell-template="due_date-cell-template"/>
                                                        <DxColumn data-field="item_type_name" :caption="$t('type')" cell-template="item_type_name-cell-template"/>   
                                                        <DxColumn data-field="payment_account_name" :caption="$t('payment_account')" header-cell-template="payment-account-header" cell-template="payment_account_name-cell-template"/>   
                                                        <DxColumn data-field="bank_account_name" :caption="$t('bank_account')" header-cell-template="bank-account-header" cell-template="cash_bank_account_name-cell-template"/>   
                                                        <DxColumn data-field="transaction_number" :caption="$t('transactioncheque_no')" header-cell-template="transaction-no-header" cell-template="transaction_number-cell-template"/>
                                                        <DxColumn data-field="amount" :sorting-method="this.$numericSort" :caption="$t('amount')" alignment="right" cell-template="amount-cell-template"/>  
                                                        <DxColumn data-field="currency" :caption="$t('currency')" cell-template="currency-cell-template"/>  
                                                        <DxColumn data-field="rate" :caption="$t('rate')" :sorting-method="this.$numericSort" alignment="right" cell-template="rate-cell-template"/> 
                                                        <DxColumn data-field="amount_local" :sorting-method="this.$numericSort" :caption="$t('local_amount')" alignment="right" header-cell-template="local-amount-header" cell-template="amount_local-cell-template"/> 
                                                        <DxColumn data-field="transaction_date" :caption="$t('date')" data-type="date" alignment="right" format="dd.MM.yyyy" header-cell-template="transaction_date-header"  cell-template="transaction_date-cell-template"/>

                                                        <!-- Yerel para birimi gösterimi için özel sütun şablonu oluşturulur --> 
                                                        <template #headerLocalTemplate="{ data: data }">
                                                            <div v-html="setColumnTemplateForLocal(data)"></div> 
                                                        </template>                                                        
                                                        <template #bank-account-header>
                                                            <div>{{ $t('bank_account') }}</div>
                                                        </template>
                                                        <template #payment-account-header>
                                                            <div>{{ $t('payment_account') }}</div>
                                                        </template>
                                                        <template #transaction-no-header>
                                                            <div>{{ $t('transaction_no') }}</div>
                                                        </template>
                                                        <template #local-amount-header>
                                                            <div>{{ $t('local_amount') }}</div>
                                                        </template>
                                                        <template #due_date-header>
                                                            <div>{{ $t('due_date') }}</div>
                                                        </template>
                                                        <template #transaction_date-header>
                                                            <div>{{ $t('transaction_date') }}</div>
                                                        </template>

                                                       
                                                        <template #id-cell-template="{ data }">
                                                            <a href="#" class="text-gray-800 text-hover-primary">
                                                                {{ (this.pageSize * this.pageIndex) + data.rowIndex + 1 }}
                                                            </a>
                                                        </template>
                                                        <template #due_date-cell-template="{ data }">
                                                            <span class="text-gray-700 p-3 align-middle text-end"> {{ previewDate(data.data.due_date) }}</span>
                                                        </template>
                                                        <template #transaction_date-cell-template="{ data }">
                                                            <span class="text-gray-700 p-3 align-middle text-end" > {{ previewDate(data.data.transaction_date) }}</span>
                                                        </template>
                                                        <template #item_type_name-cell-template="{ data }">
                                                            <span class="fw-bold p-3 align-middle" :class="{ 'text-primary': data.data.item_type == 1 , 'text-danger': data.data.item_type == 2}"> {{ data.data.item_type_name }}</span>
                                                        </template>
                                                        <template #cash_bank_account_name-cell-template="{ data }">
                                                            <span class="text-gray-700 p-3 align-middle" > {{ data.data.bank_account_name }}</span>
                                                        </template>
                                                        <template #payment_account_name-cell-template="{ data }">
                                                            <span class="text-gray-700 p-3 align-middle" >{{ data.data.payment_account_name }}</span>
                                                        </template>
                                                        <template #transaction_number-cell-template="{ data }">
                                                            <span class="text-gray-600 p-3 align-middle" >{{ data.data.transaction_number }}</span>
                                                        </template>
                                                        <template #amount-cell-template="{ data }">
                                                            <span class="text-gray-800 fw-bold text-end p-3 align-middle"> {{data.data.amount}}</span>
                                                        </template>
                                                        <template #currency-cell-template="{ data }">
                                                            <span class="text-gray-800 fw-bold p-3 align-middle"> {{data.data.currency}}</span>
                                                        </template>
                                                        <template #rate-cell-template="{ data }">
                                                            <span class="text-gray-800 fw-bold text-end p-3 align-middle"> {{data.data.rate}} </span>
                                                        </template>
                                                        <template #amount_local-cell-template="{ data }">
                                                            <span class="text-gray-800 fw-bold text-end p-3 align-middle"> {{data.data.amount_local}} </span>
                                                        </template>
                                                        <DxSummary :calculate-custom-summary="setSummaries">
                                                            <DxTotalItem column="id" summary-type="count" :display-format="`${$t('record')}: {0}`" show-in-column="isSelected"/>
                                                            <DxGroupItem
                                                                :show-in-group-footer="true"
                                                                name="amount_local"
                                                                summary-type="custom"
                                                                show-in-column="amount_local"
                                                                display-format="{0}"
                                                            /> 
                                                            <DxTotalItem name="amount_local"
                                                                summary-type="custom"
                                                                show-in-column="amount_local"
                                                            />
                                                        </DxSummary>
                                                </DxDataGrid>  
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12" v-if="getSubCredentials('I')">
                                <div class="row g-xxl-9">
                                    <div class="col-lg-12">
                                        <div class="d-grid gap-2"> 
                                            <button class="btn btn-success btn-lg mb-0" type="submit" @click="createChequeHeader()" data-kt-indicator="on"  :disabled="chequeItemsList.length == 0 || this.form.operation_account_id == '-1'"> 
                                                <span class="svg-icon svg-icon-2"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path opacity="0.3" d="M10 18C9.7 18 9.5 17.9 9.3 17.7L2.3 10.7C1.9 10.3 1.9 9.7 2.3 9.3C2.7 8.9 3.29999 8.9 3.69999 9.3L10.7 16.3C11.1 16.7 11.1 17.3 10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"/>
                                                <path d="M10 18C9.7 18 9.5 17.9 9.3 17.7C8.9 17.3 8.9 16.7 9.3 16.3L20.3 5.3C20.7 4.9 21.3 4.9 21.7 5.3C22.1 5.7 22.1 6.30002 21.7 6.70002L10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"/>
                                                </svg>
                                                </span>
                                                <strong v-if="!this.isDocketSaving"> {{ $t('save_transaction') }} </strong> 
                                                <span class="indicator-progress" v-if="this.isDocketSaving">
                                                    {{ $t('saving-transaction-please-wait') }} <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <!-- ADD TRANSACTION MODAL -->
        <div class="modal fade" id="kt_modal_add_item" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" role="dialog" aria-modal="true">
            <div class="modal-dialog modal-dialog-centered modal-xxl-90">
                <div class="modal-content"  >
                    <div class="modal-header bg-primary" id="kt_modal_add_user_header">                        
                        <div class="modal-title col-md-11 text-white">
                            <span class="fs-3 fw-bolder me-3"> {{ $t('add_chequecard') }} </span>
                            <!-- <i class="bi bi-person-fill mt-2"> </i> <span> {{getAccountName(this.form.operation_account_id)}} </span> -->
                        </div>
                        <div class="btn btn-icon btn-sm btn-active-icon-primary"
                            data-bs-dismiss="modal" aria-label="Close" ref="closeModal">
                            <span class="svg-icon svg-icon-1 text-white text-hover-dark">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                    viewBox="0 0 24 24" fill="none">
                                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1"
                                        transform="rotate(-45 6 17.3137)" fill="currentColor"></rect>
                                    <rect x="7.41422" y="6" width="16" height="2" rx="1"
                                        transform="rotate(45 7.41422 6)" fill="currentColor"></rect>
                                </svg>
                            </span>
                        </div>
                    </div>
                    <div class="modal-body scroll-y" :class="{'overlay overlay-block': this.isChequeOperationItemSaving == true}">
                        <form @submit.prevent="" class="form fv-plugins-bootstrap5 fv-plugins-framework">
                            <div class="row">
                                <div class="col-lg-12">                                    
                                    <div class="card card-xxl-stretch mb-6">
                                        <div class="row p-9 pb-4">
                                            <div class="col-lg-9">
                                                <div class="fv-row mb-4 row">
                                                    <div class="col-lg">
                                                        <label class="fs-6 fw-bold form-label mt-3" v-tag="'start_date'" >
                                                            <span>{{$t('start_due_date')}}</span>
                                                        </label>
                                                        <Datepicker :locale="$datepickerLocale()"  textInput :textInputOptions="{ format: 'dd.MM.yyyy' }" v-maska="'##.##.####'" v-model="chequeForm.start_date" 
                                                            inputClassName="form-control" format="dd.MM.yyyy" autoApply :clearable="false" weekNumbers :monthChangeOnScroll="'inverse'" name="start_date" ></Datepicker>  
                                                    </div>
                                                    <div class="col-lg">
                                                        <label class="fs-6 fw-bold form-label mt-3" v-tag="'end_date'" >
                                                            <span>{{ $t('end_due_date') }}</span>
                                                        </label>
                                                        <Datepicker :locale="$datepickerLocale()"  textInput :textInputOptions="{ format: 'dd.MM.yyyy' }" v-maska="'##.##.####'" v-model="chequeForm.end_date"
                                                            inputClassName="form-control" format="dd.MM.yyyy" autoApply :clearable="false" weekNumbers :monthChangeOnScroll="'inverse'" name="end_date" ></Datepicker>
                                                    </div>
                                                    <div class="col-lg">
                                                        <label class="fs-6 fw-bold form-label mt-3" v-tag="'position'" >
                                                            {{ $t('cheque_position') }}
                                                        </label>                                                            
                                                        <Select2 v-model="chequeForm.position" :options="lastPositionList" :settings="{ width: '100%', dropdownParent: '#kt_modal_add_item .modal-content' }" name="position" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-3">
                                                <div class="d-flex justify-content-end" data-kt-customer-table-toolbar="base">
                                                    <button type="button" class="btn btn-light-primary border border-primary" @click="getChequeLists()" data-kt-indicator="on">
                                                        <span class="svg-icon svg-icon-muted"><svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <rect y="6" width="16" height="3" rx="1.5" fill="currentColor"/>
                                                        <rect opacity="0.3" y="12" width="8" height="3" rx="1.5" fill="currentColor"/>
                                                        <rect opacity="0.3" width="12" height="3" rx="1.5" fill="currentColor"/>
                                                        </svg>
                                                        </span>
                                                        <strong v-if="!this.isListProgressing"> {{ $t('list_chequescards') }}</strong> 
                                                        <span class="indicator-progress" v-if="this.isListProgressing">
                                                            {{ $t('getting_data') }} <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                                                        </span> 
                                                    </button>
                                                </div>
                                            </div> 
                                            <div class="col-lg-12">
                                                <DxDataGrid id="gridContainer"
                                                    :show-borders="true" 
                                                    key-expr="id" 
                                                    :data-source="chequeOperationItemsList" 
                                                    :allow-column-reordering="true"  
                                                    :allow-column-resizing="true" 
                                                    :column-auto-width="true" 
                                                    :row-alternatin-enabled="true"
                                                    :hover-state-enabled="true" 
                                                    :show-row-lines="true"
                                                    :customize-columns="onCustomizeColumn"
                                                    @exporting="this.$onExporting($event , 'Cheque-transaction-items')"
                                                    :ref="'detailDataGrid'"
                                                    :scrolling="{ mode: 'virtual' }"
                                                    @onPageIndexChanged="onPageIndexChanged"
                                                    @onPageSizeChanged="onPageSizeChanged"
                                                    @row-prepared="onRowPrepared"
                                                    @option-changed="handlePropertyChanges" > 

                                                    <DxFilterRow :visible="true"/>
                                                    <DxHeaderFilter :visible="true"/>
                                                    <DxGroupPanel :visible="true"/>      
                                                    <DxExport :enabled="this.$getUser().is_allow_export" :formats="['xlsx','pdf']" :allow-export-selected-data="false"/>
                                                    <DxPaging :page-size="pageSize"/>
                                                    <DxPager :visible="false" :allowed-page-sizes="pageSizesLengt" :show-page-size-selector="showPageSizeSelect" :show-info="true" :show-navigation-buttons="true"/> 
                                                    <DxSearchPanel :visible="true"/> 
                                                    
                                                    <DxColumn data-field="isSelected" caption="#" :allow-filtering="false" alignment="center" header-cell-template="is-selected-header" cell-template="is-selected-cell-template" :allow-exporting="false"/> 
                                                    <DxColumn data-field="id" caption="" alignment="right" cell-template="id-cell-templates" :allow-exporting="false"/>
                                                    <DxColumn data-field="due_date" :caption="$t('due_date')" data-type="date" alignment="right" format="dd.MM.yyyy" header-cell-template="due_date-header" cell-template="due_date-cell-template"/>
                                                    <DxColumn data-field="last_position_name" :caption="$t('last_position')" header-cell-template="last_position_name-header" cell-template="position-cell-template"/>   
                                                    <DxColumn data-field="last_position_account_name" :caption="$t('last_position_account_name')" header-cell-template="last_position_account_name-header" cell-template="last_position_account_name-cell-template"/>   
                                                    <DxColumn data-field="item_type_name" :caption="$t('type')" cell-template="item_type_name-cell-template"/>   
                                                    <DxColumn data-field="docket_number" :caption="$t('docket_no')" header-cell-template="docket-no-header" cell-template="docket_number-cell-template"/>
                                                    <DxColumn data-field="payment_account_name" :caption="$t('account')" cell-template="payment_account_name-cell-template"/>   
                                                    <DxColumn data-field="amount" :sorting-method="this.$numericSort" :caption="$t('amount')" alignment="right" cell-template="amount-cell-template"/>  
                                                    <DxColumn data-field="currency" :caption="$t('currency')" cell-template="currency-cell-template"/>  
                                                    <DxColumn data-field="rate" :caption="$t('rate')" alignment="right" cell-template="rate-cell-template"/> 
                                                    <DxColumn data-field="amount_local" :sorting-method="this.$numericSort" :caption="$t('local_amount')" alignment="right" header-cell-template="local-amount-header" cell-template="amount_local-cell-template"/> 
                                                    <DxColumn data-field="bank_account_name" :caption="$t('bank_account')" header-cell-template="bank-account-header" cell-template="cash_bank_account_name-cell-template"/>
                                                    <DxColumn data-field="transaction_number" :caption="$t('transaction_no')" header-cell-template="transaction-no-header" cell-template="transaction_number-cell-template"/>
                                                    <DxColumn data-field="cheque_number" :caption="$t('cheque_no')" header-cell-template="cheque-no-header" cell-template="cheque_number-cell-template"/>
                                                    <DxColumn data-field="transaction_date" :caption="$t('date')" data-type="date" alignment="right" format="dd.MM.yyyy" cell-template="transaction_date-cell-template"/>

                                                    <!-- Yerel para birimi gösterimi için özel sütun şablonu oluşturulur --> 

                                                    <template #is-selected-header>                                
                                                    <div class="form-check form-check-sm form-check-custom form-check-solid">
                                                        <input class="form-check-input" type="checkbox" v-model="form.isSelectedAll" @change="onSelectAll()"> 
                                                    </div>
                                                    </template>
                                                    <template #headerLocalTemplate="{ data: data }">
                                                        <div v-html="setColumnTemplateForLocal(data)"></div> 
                                                    </template>
                                                    <template #bank-account-header>
                                                        <div>{{ $t('bank_account') }}</div>
                                                    </template>
                                                    <template #transaction-no-header>
                                                        <div>{{ $t('transaction_no') }}</div>
                                                    </template>
                                                    <template #cheque-no-header>
                                                        <div>{{ $t('cheque_no') }}</div>
                                                    </template>
                                                    <template #card-type-header>
                                                        <div>{{ $t('card_type') }}</div>
                                                    </template>
                                                    <template #docket-no-header>
                                                        <div>{{ $t('docket_no') }}</div>
                                                    </template>
                                                    <template #local-amount-header>
                                                        <div>{{ $t('local_amount') }}</div>
                                                    </template>
                                                    <template #due_date-header>
                                                        <div>{{ $t('due_date') }}</div>
                                                    </template>
                                                    <template #last_position_name-header>
                                                        <div>{{ $t('last_position') }}</div>
                                                    </template>
                                                    <template #last_position_account_name-header>
                                                        <div>{{ $t('last_position') }}</div><div> {{ $t('account_name') }}</div>
                                                    </template>

                                                    <template #is-selected-cell-template="{ data }">
                                                        <span>
                                                            <div class="form-check form-check-sm form-check-custom form-check-solid justify-content-center" v-if="!data.data.is_used && data.data.id !== null && data.data.id !== ''">
                                                                <input class="form-check-input" type="checkbox" v-model="data.data.isSelected" :disabled="data.data.is_used" />
                                                            </div>
                                                            <span class="svg-icon svg-icon-1 svg-icon-success" v-if="data.data.is_used">
                                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" @click="updateItem(data.data.id)">
                                                                    <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"></rect>
                                                                    <path d="M10.4343 12.4343L8.75 10.75C8.33579 10.3358 7.66421 10.3358 7.25 10.75C6.83579 11.1642 6.83579 11.8358 7.25 12.25L10.2929 15.2929C10.6834 15.6834 11.3166 15.6834 11.7071 15.2929L17.25 9.75C17.6642 9.33579 17.6642 8.66421 17.25 8.25C16.8358 7.83579 16.1642 7.83579 15.75 8.25L11.5657 12.4343C11.2533 12.7467 10.7467 12.7467 10.4343 12.4343Z" fill="currentColor"></path>
                                                                </svg>
                                                            </span>
                                                        </span>
                                                    </template>
                                                    <template #id-cell-templates="{ data }">
                                                        <a href="#" class="text-gray-800 text-hover-primary">
                                                            {{ getRowNumber(data) }}
                                                        </a>
                                                    </template>
                                                    <template #transaction_date-cell-template="{ data }">
                                                            <span class="text-gray-700 p-3 align-middle text-end" > {{ previewDate(data.data.transaction_date) }}</span>
                                                    </template>
                                                    <template #docket_number-cell-template="{ data }">
                                                        <span class="text-gray-600 p-3 align-middle">{{ data.data.docket_number }}</span>
                                                    </template>
                                                    <template #position-cell-template="{ data }">
                                                        <span class="text-gray-600 p-3 align-middle">{{ data.data.last_position_name }}</span>
                                                    </template>
                                                    <template #last_position_account_name-cell-template="{ data }">
                                                        <span class="text-gray-600 p-3 align-middle">{{ data.data.last_position_account_name }}</span>
                                                    </template>
                                                    <template #item_type_name-cell-template="{ data }">
                                                        <span class="fw-bold p-3 align-middle" :class="{ 'text-primary': data.data.item_type == 1 , 'text-danger': data.data.item_type == 2}"> {{ data.data.item_type_name }}</span>
                                                    </template>
                                                    <template #cash_bank_account_name-cell-template="{ data }">
                                                        <span class="text-gray-700 p-3 align-middle"> {{ data.data.bank_account_name }}</span>
                                                    </template>
                                                    <template #payment_account_name-cell-template="{ data }">
                                                        <span class="text-gray-700 p-3 align-middle">{{ data.data.payment_account_name }}</span>
                                                    </template>
                                                    <template #due_date-cell-template="{ data }">
                                                        <span class="text-gray-700 p-3 align-middle text-end"> {{ previewDate(data.data.due_date) }}</span>
                                                    </template>
                                                    <template #transaction_number-cell-template="{ data }">
                                                        <span class="text-gray-600 p-3 align-middle">{{ data.data.transaction_number }}</span>
                                                    </template>
                                                    <template #cheque_number-cell-template="{ data }">
                                                        <span class="text-gray-600 p-3 align-middle">{{ data.data.cheque_number }}</span>
                                                    </template>
                                                    <template #amount-cell-template="{ data }">
                                                        <span class="text-gray-800 fw-bold text-end p-3 align-middle"> {{data.data.amount}}</span>
                                                    </template>
                                                    <template #currency-cell-template="{ data }">
                                                        <span class="text-gray-800 fw-bold p-3 align-middle"> {{data.data.currency}}</span>
                                                    </template>
                                                    <template #rate-cell-template="{ data }">
                                                        <span class="text-gray-800 fw-bold text-end p-3 align-middle"> {{data.data.rate}} </span>
                                                    </template>
                                                    <template #amount_local-cell-template="{ data }">
                                                        <span class="text-gray-800 fw-bold text-end p-3 align-middle"> {{data.data.amount_local}} </span>
                                                    </template>

                                                    <DxSummary>
                                                        <DxTotalItem column="id" summary-type="count" :display-format="`${$t('record')}: {0}`" show-in-column="isSelected"/>
                                                    </DxSummary>
                                                </DxDataGrid> 
                                            </div>
                                            <div class="col-lg-12 mt-10">
                                                <div class="card">
                                                    <div class="d-grid gap-2"> 
                                                        <button type="button" class="btn btn-success btn-lg" @click="this.addChequeOperationItem()"
                                                            :disabled="isModalItemButtonDisabled == null || isModalItemButtonDisabled == undefined">
                                                            <strong>Add To List</strong> 
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                        <div class="overlay-layer bg-dark bg-opacity-5" v-if="this.isChequeOperationItemSaving == true">
                            <div class="spinner-border text-primary" role="status">
                                <span class="visually-hidden">{{ $t('loading') }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> 

        <!-- Transaction List -->
        <div class="modal fade" id="kt_modal_transaction_list" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" role="dialog" aria-modal="true">
            <TransactionListModal ref="TransactionListModal" :transaction-type="7" :account-id="this.form.operation_account_id" :account-name="form.operation_account_name"/>
        </div>

        <!-- Statement Modal  -->
        <div class="modal fade" id="kt_modal_account_report_selection" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" role="dialog" aria-modal="true">
           <AccountReports ref="AccountReports" :account-name="form.operation_account_name" :account-id="form.operation_account_id" :account-type="form.operation_account_type" />
        </div>

        <!-- Search Account Modal -->
        <div class="modal fade" id="kt_search_account_modal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" role="dialog" aria-modal="true">
            <SearchOperationAccountWithSelect ref="SearchOperationAccountWithSelect" />
        </div>
    </div>
</template>

<script>
import axios from "axios";

import moment from 'moment';
import { DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxExport, DxPaging, DxPager, DxColumn, DxSearchPanel, DxTotalItem, DxSummary, DxGroupItem,DxEditing  } from 'devextreme-vue/data-grid';
import TransactionListModal from '../TransactionListModal.vue';
import SearchOperationAccountWithSelect from '../../Accounts/Modals/SearchOperationAccountWithSelect.vue';
 
export default {
  name: "ChequeOperationsCreate",
  components:{
        DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxExport, DxPaging, DxPager, DxColumn, DxSearchPanel, DxTotalItem, DxSummary, DxGroupItem, TransactionListModal, SearchOperationAccountWithSelect,DxEditing
  },
  data() {
    return { 
        userData: this.$getUser(),
        pageSize: null,
        pageIndex: 0,
        pageSizeNo: 10,
        pageIndexNo: 0,
        searchbar: '',
        isOpenDescriptionDropdown: false,
        chequeOperationItemsList: [],
        chequeItemsList: [],
        recordTypeList: [
            { id: 1, text: this.$t('cheque')},
            { id: 2, text: this.$t('card')},
        ],
        transactionTypeList: [
            { id: 0, text: this.$t('all')},
            { id: 1, text: this.$t('incoming_cheque'), type: 1},
            { id: 2, text: this.$t('outgoing_cheque'), type: 1},
            { id: 1, text: this.$t('incoming_card'), type: 2},
            { id: 2, text: this.$t('outgoing_card'), type: 2},
        ],
        accountTypeList: [
            { id: '-1', text: this.$t('select_an_option')},
            { id: 12, text: this.$t('customer_supplier')},
            { id: 5, text: this.$t('personnel')},
            { id: 8, text: this.$t('asset')},
            { id: 15, text: this.$t('other_account')}
        ],
        localCurrency: null,
        chequeForm: {
            start_date: moment(),
            end_date: moment().add(60, 'days'),
            position: '-1',
            payment_account_id: '-1',
            bank_account_id: '-1'
        },
        form: {
            docket_type: 14,
            record_date: moment(),
            docket_number: null, 
            account_name: '-1',
            account_id: '-1',
            operation_account_id: '-1',
            operation_account_type: 0,
            cheque_position: '-1',
            transaction_type: 1,
            isSelectedAll: false,
            record_type: 1,
            operation_account_name: null
        },
        chequeSummaryList: [],
        isDocketSaving: false,
        isChequeOperationItemSaving: false,
        isListProgressing: false,
        accountNameList: [{id: '-1', text: this.$t('select_an_option')}],
        targetPositionList: [],
        lastPositionList: [],
        menuSelection: '/ChequeOperationHelppage',
        iconView : false,
        accountTypeName: []
    };
  },
  computed: { 
    setColumnTemplateForLocal(){
        return (value)=>{
            const captionValue = value.column.caption.replace(this.$t('local'), ' ');
            return this.localCurrency == null ? this.$t(captionValue) : this.localCurrency + '<br>' + this.$t(captionValue);          
        }
   },
    previewDate(){
      return (value)=>{
       if (value) {
          return moment(new Date(value)).format('DD.MM.YYYY')
        }
      }
    },
    isModalItemButtonDisabled() {
       return this.chequeOperationItemsList.find(item =>item.isSelected == true );
    },
    filteredAccountNameList() {
        return this.accountNameList.filter(p => { 
            return p.id == '-1' || (p.account_type == 1 || p.account_type == 2 || p.account_type == 4 || p.account_type == 5 || p.account_type == 15);
        });
    },
    transactionTypeListWithNoSelection() {        
        if(this.form.record_type == 1) {
            if(!this.$isCredentialActive(44, 'I', 39)) {
                return this.transactionTypeList.filter(p => { 
                    return p.id !== 0 && p.type == 1 && p.id !== 1;
                });
            }
            if(!this.$isCredentialActive(45, 'I', 39)) {
                return this.transactionTypeList.filter(p => { 
                    return p.id !== 0 && p.type == 1 && p.id !== 2;
                });
            }
        } else {
            if(!this.$isCredentialActive(46, 'I', 39)) {
                return this.transactionTypeList.filter(p => { 
                    return p.id !== 0 && p.type == 2 && p.id !== 1;
                });
            }
            if(!this.$isCredentialActive(47, 'I', 39)) {
                return this.transactionTypeList.filter(p => { 
                    return p.id !== 0 && p.type == 2 && p.id !== 2;
                });
            }
        }
        return this.transactionTypeList.filter(p => { 
            return p.id !== 0 && p.type == this.form.record_type;
        });
    },
    getAccountName() {
        return (value)=>{
            if (value !== null && value !== '' && value !== '-1' && value !== undefined) {
                return this.accountNameList.find(element => {
                    return element.id == value
                }).text;
            }
        }
    },
    showPageSizeSelector() {
        return this.chequeItemsList.length > this.pageSize;
    },
    pageSizes() {
        let arr = [];
        let x = 1;
        let loop = (this.chequeItemsList.length / this.pageSize);
        for (let i = 1; i <= loop && i <= 5; i++) {
            arr.push(this.pageSize * x);
            x++;
        }
        if(loop > 5) arr.push(100);
        if(loop > 1) arr.push('all');
        return arr;
    },
    showPageSizeSelect() {
        return this.chequeOperationItemsList.length > this.pageSizeNo;
    },
    pageSizesLengt() {
        let arr = [];
        let x = 1;
        let loop = (this.chequeOperationItemsList.length / this.pageSizeNo);
        for (let i = 1; i <= loop && i <= 5; i++) {
            arr.push(this.pageSizeNo * x);
            x++;
        }
        if(loop > 5) arr.push(100);
        if(loop > 1) arr.push('all');
        return arr;
    },
    getAccountTypes() {
        let name = null;
        //Waiting
        if(this.form.cheque_position == 0) {name = "Customer, Supplier, Cash, Bank, Personnel, Other Account";}
        //Giro
        if(this.form.cheque_position == 1) {name = "Customer, Supplier, Personnel, Other Account";}
        //Deposit
        if(this.form.cheque_position == 2) {name = "Bank";}
        //Return + Incoming
        if(this.form.cheque_position == 3 && this.form.transaction_type == 1) {name = "Customer, Supplier";}
        //Paid
        if(this.form.cheque_position == 4) {name = "Cash, Bank";}
        //Not Paid + Incoming
        if(this.form.cheque_position == 5 && this.form.transaction_type == 1) {name = "Customer, Supplier";}
        
        //Return + Outgoing
        if(this.form.cheque_position == 3 && this.form.transaction_type == 2) {name = "Customer, Supplier, Other Account";}
        //Not Paid + Outgoing
        if(this.form.cheque_position == 5 && this.form.transaction_type == 2) {name = "Customer, Supplier, Other Account";}

        return name;
    },
    getSubCredentials() {
      return (operation)=>{
        let isView = false;
        if(this.form.record_type == 1 && this.form.transaction_type == 1) isView = this.$isCredentialActive(44, operation, 39);
        if(this.form.record_type == 1 && this.form.transaction_type == 2) isView = this.$isCredentialActive(45, operation, 39);
        if(this.form.record_type == 2 && this.form.transaction_type == 1) isView = this.$isCredentialActive(46, operation, 39);
        if(this.form.record_type == 2 && this.form.transaction_type == 2) isView = this.$isCredentialActive(47, operation, 39);
        return isView;
      }
    },
    recordTypeFilteredList() {
      if(!this.$isCredentialActive(44, 'I', 39) && !this.$isCredentialActive(45, 'I', 39)) {
        return this.recordTypeList.filter(p => p.id != 1);
      }
      if(!this.$isCredentialActive(46, 'I', 38) && !this.$isCredentialActive(47, 'I', 38)) {
        return this.recordTypeList.filter(p => p.id != 2);
      }      
      return this.recordTypeList;
    },
    getMinTransactionDate(){
        return moment(new Date(this.userData.last_transaction_date)).add(1, 'days').format('DD.MM.YYYY');
    },
  },
  methods: { 
    getData() { 
        this.$Progress.start();
        this.form.transaction_type = this.transactionTypeListWithNoSelection.length > 0 ? this.transactionTypeListWithNoSelection[0].id : 1;
        const parameters = {
            session_id: this.$getUser().session_id,
            docket_sub_type: this.form.transaction_type,
            cheque_position: '-1'
        };        
        const requestOne =  axios.post('/api/Helper/GetPositions', parameters, {'Content-Type': 'application/json'});
        axios.all([requestOne]).then(axios.spread((...responses) => {
            this.targetPositionList = responses[0].data;
            this.targetPositionList.unshift({ id: '-1', text: this.$t('select_a_position_for')});
            this.localCurrency = this.$getUser().currency_code; 
            this.$Progress.finish();
        }))
        .catch(errors => { 
            this.$Progress.finish();
            console.error(errors); 
        }); 
    },
    handlePropertyChange(e) {
        if(e.name == "paging") {
            this.pageIndex = e.component.pageIndex();
        }
    },
    handlePropertyChanges(e) {
        if(e.name == "paging") {
            this.pageIndexNo = e.component.pageIndexNo();
        }
    },
    openModal() {
        this.$refs.detailDataGrid.instance.clearFilter();
        this.chequeForm.start_date = moment();
        this.chequeForm.end_date = moment().add(60, 'days');
        const parameters = {
            session_id: this.$getUser().session_id,
            docket_sub_type: this.form.transaction_type,
            cheque_position: this.form.cheque_position
        };        
        this.form.isSelectedAll = false;
        const requestOne =  axios.post('/api/Helper/GetPositions', parameters, {'Content-Type': 'application/json'});
        axios.all([requestOne]).then(axios.spread((...responses) => {
            this.lastPositionList = responses[0].data;
            this.lastPositionList.unshift({ id: '-1', text: this.$t('all')});
            if(this.lastPositionList.length > 0) {
                this.chequeForm.position = this.lastPositionList[0].id;
            }
            this.getChequeLists();
        }))
        .catch(errors => {
            console.error(errors); 
        }); 
    },
    getChequeLists() {
      this.$Progress.start();
      this.isListProgressing = true;
      this.chequeForm.start_date = (this.chequeForm.start_date == null || this.chequeForm.start_date == '') ? moment() : this.chequeForm.start_date;
      const params = {        
        session_id: this.$getUser().session_id,
        start_date: moment(this.chequeForm.start_date).format('YYYY-MM-DD'),
        end_date: moment(this.chequeForm.end_date).format('YYYY-MM-DD'),
        transaction_type: this.form.transaction_type,
        payment_account_id: null,
        // bank_account_id: this.chequeForm.bank_account_id,
        temp_session_id: this.$getSessionStorage('tmp_session_id'),
        last_position: this.chequeForm.position,
        target_position: this.form.cheque_position,
        record_type: this.form.record_type
      };  
      if(this.form.cheque_position == '0' || this.form.cheque_position == '3' || this.form.cheque_position == '5') {
        //|| (this.form.transaction_type == '2' && this.form.cheque_position == '4')
        params.payment_account_id = this.form.operation_account_id;
      }
      axios.post('api/Cheque/GetChequeForOperations', params, {'Content-Type': 'application/json'})
        .then((response) => { 
            this.chequeOperationItemsList = response.data;
            this.$Progress.finish();
             setTimeout(() => {
                this.isListProgressing = false;
            }, 500);
        })
        .catch((error) => {
            console.error(error);
            this.$swal(this.$t('failed'), this.$t('data_could_not_be_savedplease_refresh_the_page_and_try_again'), "error");   
            this.$removeSessionStorage('data'+ '_OTH001');
            this.$Progress.finish();
             setTimeout(() => {
                this.isListProgressing = false;
            }, 500);
        });
    },
    addChequeOperationItem(){
        this.isChequeOperationItemSaving = true;
        const that = this;
        const params = {
            session_id: this.$getUser().session_id,
            tmp_session_id: this.$getSessionStorage('tmp_session_id'),
            selectedChequeIds: []
        };
        this.chequeOperationItemsList.forEach((value) => {
            if(value.isSelected && !value.is_used){
                params.selectedChequeIds.push(value.id);
            }
        });
        axios.post('api/Cheque/CreateChequeOperationItem', params, {'Content-Type': 'application/json'})
        .then((response) => {
            if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){  
                if(response.data.cheque_items.length > 0){
                    this.$setSessionStorage('tmp_session_id', response.data.cheque_items[0].session_id); 
                    this.chequeItemsList = response.data.cheque_items;
                    this.chequeSummaryList = response.data.cheque_summary;
                    this.$refs.closeModal.click();
                }  
            }
            this.isChequeOperationItemSaving = false;
        })
        .catch(() => {
            this.isChequeOperationItemSaving = false;
            this.$swal(this.$t('failed'), this.$t('data_could_not_be_savedplease_refresh_the_page_and_try_again'), "error");   
        })
        .finally(() => { 
            setTimeout(() => {
                that.isChequeOperationItemSaving = false;
            }, 500);
        });  
    },
    deleteAllChequeItem(isDeleteAll) {
         this.$swal.fire({
            title: this.$t('are_you_sure_you_want_to_remove_all_items'),
            confirmButtonColor: "#f1416c",
            showDenyButton: false,
            showCancelButton: true,
        cancelButtonText: this.$t('cancel'),
            confirmButtonText: this.$t('delete'),
            icon: 'info'
        })
        .then((result) => {
            if (result.isConfirmed) { 
                    this.$Progress.start();
                    const params = { 
                        id: null, 
                        selectedChequeIds: [],
                        session_id: this.$getUser().session_id,
                        tmp_session_id: this.$getSessionStorage('tmp_session_id'),
                        is_all: isDeleteAll
                    };
                    if(isDeleteAll !== 1) {
                        this.chequeItemsList.forEach((item) => { 
                            if(item.isSelected){ 
                                params.selectedChequeIds.push(item.id);
                            }
                        });
                    }
                    axios.post('api/Cheque/DeleteChequeOperationItem', params, {'Content-Type': 'application/json'})
                    .then((response) => {
                        if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){  
                            if(response.data.cheque_items.length > 0){
                                this.$setSessionStorage('tmp_session_id', response.data.cheque_items[0].session_id);
                            }   
                            this.chequeItemsList = response.data.cheque_items;
                            this.chequeSummaryList = response.data.cheque_summary;
                        } 
                        this.$Progress.finish(); 
                    })
                    .catch(() => {
                        this.$Progress.finish();
                    });  
            }
        }); 
    },
    deleteChequeItem(e) {
        this.$Progress.start();
        const params = { 
            id: null, 
            selectedChequeIds: [e.data.id],
            session_id: this.$getUser().session_id,
            tmp_session_id: this.$getSessionStorage('tmp_session_id'),
            is_all: 0
        };
        axios.post('api/Cheque/DeleteChequeOperationItem', params, {'Content-Type': 'application/json'})
        .then((response) => {
            if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){  
                if(response.data.cheque_items.length > 0){
                    this.$setSessionStorage('tmp_session_id', response.data.cheque_items[0].session_id);
                }   
                this.chequeItemsList = response.data.cheque_items;
                this.chequeSummaryList = response.data.cheque_summary;
            } 
            this.$Progress.finish(); 
        })
        .catch(() => {
            this.$Progress.finish();
        });  
    },
    createChequeHeader(){
        this.$checkSelect2Validation('poliform');
        if(!document.forms['poliform'].reportValidity()){
            return;
        }
        this.isDocketSaving = false;
        this.$swal.fire({
            title: this.$t('are_you_sure_you_want_to_save_this_transaction'),
            confirmButtonColor: "#50cd89",
            showDenyButton: false,
            showCancelButton: true,
        cancelButtonText: this.$t('cancel'),
            confirmButtonText: this.$t('save'),
            icon: 'info'
        })
        .then((result) => {
            if (result.isConfirmed) {
                this.$Progress.start();
                this.isDocketSaving = true;
                const that = this;
                const params = { 
                    session_id: this.$getUser().session_id,
                    tmp_session_id: this.$getSessionStorage('tmp_session_id'),
                    record_date: this.form.record_date,
                    docket_sub_type: this.form.transaction_type,
                    cheque_position: this.form.cheque_position,
                    account_id: this.form.operation_account_id,
                    record_type: this.form.record_type
                };  
                params.record_date = moment(params.record_date).format('YYYY-MM-DD[T]HH:mm:ss'); 
                axios.post('api/Cheque/CreateChequeOperationHeader', params, {'Content-Type': 'application/json'})
                .then((response) => {
                    if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){ 
                        this.$removeSessionStorage('tmp_session_id'); 
                        this.$swal(this.$t('saved'), this.$t('transaction_saved_successfully'), 'success');
                        this.$setSessionStorage('record_id', response.data); 
                        this.$setSessionStorage('refreshList', true); 
                        this.$router.push({ name: 'ChequeOperationsUpdate' });
                    }  
                    this.$Progress.finish(); 
                })
                .catch(() => { 
                    this.$Progress.finish(); 
                    this.$swal(this.$t('failed'), this.$t('data_could_not_be_savedplease_refresh_the_page_and_try_again'), 'error');
                })
                .finally(() => { 
                    setTimeout(() => {
                        that.isDocketSaving = false;
                        that.$Progress.finish(); 
                    }, 500);
                }); 
            }
        }); 
    },
    onPageIndexChanged(e) {
      this.pageIndex = e.component.pageIndex();
    },
    onPageSizeChanged(e) {
      this.pageSize = e.component.pageSize();
    },
    getRowNumber(data) {
      return (this.pageIndex * this.pageSize) + data.rowIndex + 1;
    },
    onCustomizeColumn(e){
        if(e){
            if(!e._isUpdated){
                if(e.length > 0){ 
                    e._isUpdated = true;
                }
                e.forEach((column) => {   
                    if(column.dataField == 'amount_local'){ 
                         column.caption = this.$t('local_amount');
                         column.headerCellTemplate = 'headerLocalTemplate';
                     }
                });  
            } 
        } 
    },
    onRowPrepared(e){ 
        if(e.rowType === 'data') {
            if (e.data.is_used == '1') {
                e.rowElement.classList.add('bg-light');  
            }
        } 
    }, 
    onChangeChequeType() {
        this.form.cheque_position = '-1';
        this.form.operation_account_id = '-1';
        this.form.operation_account_name = null;
        this.form.operation_account_type = 0;
        this.accountNameList = [{ id: '-1', text: this.$t('select_an_option')}];
        this.getData();
    },
    async helpPageViewIcon()
    {
        const queryparameter = {
            session_id : this.$getUser().session_id,
            menu_selection : '/ChequeOperationHelppage'
        };
        axios.post('api/HelpPage/HelpPagesContent', queryparameter, {'Content-Type': 'application/json'})
        .then((response) => { 
            if(!response.data.error){ 
                this.iconView = response.data;
            }
        })
    }, 
    onSelectAll() {
    this.chequeOperationItemsList.forEach((value) => {
        value.isSelected = this.form.isSelectedAll;
    });
    },
    setSummaries(options){
        if(options.name == "amount_local"){
            if(options.summaryProcess === 'start'){
                options.totalValue = 0;
            }
            else if(options.summaryProcess === 'calculate'){
                var amount_local = parseFloat(options.value.amount_local.replaceAll(',', ''));
                (options.totalValue += amount_local);
            }
            else if(options.summaryProcess === 'finalize'){ 
                options.totalValue = Intl.NumberFormat('en-US', { minimumFractionDigits: 2 }).format(options.totalValue);
            }
        }
    },
    onOpenTransactionListModal() {
        this.$refs.TransactionListModal.getData();
    },
    onChangeAccount(event) {
        this.form.operation_account_name = event.name;
    },
    onOpenAccountReport(){
        this.$refs.AccountReports.getData();
        this.$refs.AccountReports.setModalCriteriasToDefault();
    },
    openSearchModal(searchText) {
        this.$refs.SearchOperationAccountWithSelect.getData(this.form.transaction_type, this.form.cheque_position, searchText);
    },
    onClickSearchButton() {
        this.$refs.searchAccountButton.click();
    },
    getAccountDetail(id) {       
        this.form.operation_account_id = id;
        this.chequeForm.amount = 0.00;
        this.chequeForm.amount_local = 0.00;
        this.form.operation_account_name = null;
        if (id == '-1' || id == null || id == undefined) return;
        const params = {
            id: id,
            session_id: this.$getUser().session_id
        }; 
        axios.post('api/CompanyAccounts/GetAccountById', params, {'Content-Type': 'application/json'})
        .then((response) => {
            this.form.operation_account_name = this.$unlock(response.data.name);
            this.form.account_id = this.$unlock(response.data.account_id);
            this.form.operation_account_type = response.data.account_type;
        });
    },
    onChangeRecordType() {
        this.form.transaction_type = this.transactionTypeListWithNoSelection.length > 0 ? this.transactionTypeListWithNoSelection[0].id : 1;
    }
  },
  created() {
    this.helpPageViewIcon();
    this.$setSessionStorage('refreshList', true);
    this.$removeSessionStorage('tmp_session_id'); 
    this.getData();
  },
};
</script>